import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const logSerproRepository = createRepository({
  path: 'log-serpro',
  restApi,
  queryTransform: {
    consulta: query.ilikeWithoutSplit('consulta'),
    dataInicio: query.gte('dataInicio'),
    dataFim: query.lte('dataFim'),
    ...paginate
  }
})

export default logSerproRepository
